import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const baseStyles = xcss({
	height: '40px',
	width: '44px',
	borderRadius: 'radius.small',
	border: 'none',
});

const placeholderStyles = xcss({
	backgroundColor: 'color.background.neutral',
});

export const PlaceholderThumbnail = (): React.JSX.Element => {
	return <Box xcss={[baseStyles, placeholderStyles]} testId="image-picker-placeholders" />;
};
